import { observer } from "mobx-react-lite";
import { useAppContext } from "../../../../shared/functions/Context";
import { useEffect, useState } from "react";
import CriteriaBox from "../components/CriteriaBox";
import { ErrorBoundary } from "../../../../shared/components/error-boundary/ErrorBoundary";
import {
  IRateAssignment,
  defaultRatingAssignment,
} from "../../../../shared/models/three-sixty-feedback-models/RateAssignments";
import { dateFormat_YY_MM_DY } from "../../../shared/utils/utils";
import { hideModalFromId } from "../../../../shared/functions/ModalShow";
import MODAL_NAMES from "../../../dialogs/ModalName";
import SavedAlertModal from "../../shared-components/SavedAlertModal";
import Modal from "../../../../shared/components/Modal";

const QuestionnairePreview = observer(() => {
  const { api, store } = useAppContext();
  const [ratingAssignments, setRatingAssignments] = useState<IRateAssignment>({
    ...defaultRatingAssignment,
  });

  const valueCriteria = store.value
    ? store.value.all.map((value) => {
        return value.asJson;
      })
    : [];
  const leadershipCriteria = store.leadership.all.map((criteria) => {
    return criteria.asJson;
  });
  const [onNext, setNext] = useState<Boolean>(false);

  const onBack = () => {
    setNext(false);
  };
  const toggleNext = () => {
    setNext(true);
  };
  const onCancel = () => {
    hideModalFromId(MODAL_NAMES.THREE_SIXTY_FEEDBACK.QUESTIONNAIRE_PREVIEW);
  };

  useEffect(() => {
    const saveRatingAssignments = async () => {
      try {
        await api.ratingAssignments.create(ratingAssignments);
      } catch (error) {
        console.log(error);
      }
    };

    if (
      ratingAssignments.isActive !== false &&
      Object.keys(ratingAssignments.feedbackAssignments).length !== 0
    ) {
      saveRatingAssignments();
    }
  }, [ratingAssignments]);

  useEffect(() => {
    const load = () => {
      return new Promise(async (reject) => {
        try {
          await api.value.getAll();
          await api.leadership.getAll();
          await api.user.getAll();
        } catch (error) {
          reject(error); // Reject the promise if an error occurs
        }
      });
    };
    load()
      .then(() => {})
      .catch((error) => {
        console.log("Error loading data:", error);
      });
  }, []);

  return (
    <div
      className="create-template-modal uk-modal-dialog uk-modal-body uk-margin-auto-vertical"
      data-uk-overflow-auto
      style={{
        width: "80%",
        maxWidth: "800px",
        height: "90%",
        maxHeight: "800px",
        padding: "2rem",
      }}
    >
      <button
        className="uk-modal-close-default"
        type="button"
        data-uk-close
      ></button>
      <div className="uk-card uk-card-small">
        <h4>Questionnaire</h4>
        {/* Conditionally render CriteriaBox if store.value is truthy */}
        <div style={{ marginBottom: "1rem" }}></div>
        <div className="uk-form-controls" style={{ marginBottom: "1rem" }}>
          <label>Select Start Date</label>
          <input
            id="kpi-target"
            className="uk-input uk-form-small"
            placeholder="KPI Annual Target"
            type="date"
            value={
              ratingAssignments.midtermReview.startDate
                ? new Date(ratingAssignments.midtermReview.startDate)
                    .toISOString()
                    .split("T")[0]
                : ""
            }
            onChange={(e) =>
              setRatingAssignments((prevRatingAssignments) => ({
                ...prevRatingAssignments,
                midtermReview: {
                  ...prevRatingAssignments.midtermReview,
                  startDate: new Date(e.target.value).getTime(), // store as timestamp
                },
              }))
            }
            required
          />
        </div>

        <div className="uk-form-controls" style={{ marginBottom: "1rem" }}>
          <label>Select End Date</label>
          <input
            id="kpi-target"
            className="uk-input uk-form-small"
            placeholder="KPI Annual Target"
            type="date"
            value={
              ratingAssignments.midtermReview.endDate
                ? new Date(ratingAssignments.midtermReview.endDate)
                    .toISOString()
                    .split("T")[0]
                : ""
            }
            onChange={(e) =>
              setRatingAssignments((prevRatingAssignments) => ({
                ...prevRatingAssignments,
                midtermReview: {
                  ...prevRatingAssignments.midtermReview,
                  endDate: new Date(e.target.value).getTime(), // store as timestamp
                },
              }))
            }
            required
          />
        </div>

        {!onNext ? (
          <ErrorBoundary>
            <h3 style={{ color: "black" }}>Values</h3>
            <CriteriaBox value={valueCriteria} />
          </ErrorBoundary>
        ) : (
          <>
            <h3 style={{ color: "black" }}>Leadership</h3>
            <CriteriaBox value={leadershipCriteria} />
            <button
              className="uk-button uk-button-small uk-button-mute"
              onClick={onBack}
              style={{ marginRight: "1rem" }}
            >
              Back
            </button>
          </>
        )}
        {!onNext && (
          <button
            style={{ marginRight: "1rem" }}
            onClick={toggleNext}
            className="template-container uk-button uk-button-small uk-button-primary"
          >
            Next
          </button>
        )}
        <button
          onClick={onCancel}
          className="template-container uk-button uk-button-small uk-button-danger"
          style={{ marginLeft: "1rem" }}
        >
          Cancel
        </button>
        <Modal
          modalId={
            MODAL_NAMES.THREE_SIXTY_FEEDBACK.SUCCESSFULLY_SUBMITTED_MODAL
          }
        >
          <SavedAlertModal />
        </Modal>
      </div>
    </div>
  );
});
export default QuestionnairePreview;
